import { render } from "./Elemento_ElemExam.vue?vue&type=template&id=190a8d4e"
import script from "./Elemento_ElemExam.vue?vue&type=script&lang=js"
export * from "./Elemento_ElemExam.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__